import React, { Component } from 'react';
import { ReactComponent as IconArrow } from '../../media/icons/arrow_right.svg';


export default class PictureCarousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            data: []
        };
        this.setPopup = this.props.setPopup.bind(this);
        this.setPicture = this.props.setPicture.bind(this);
    }


    componentDidMount() {
        if (this.props.data.length >= 1) {
            this.setState({
                data: this.props.data
            });
        }
    }


    componentDidUpdate() {
        if (this.props.data != this.state.data) {
            this.setState({
                data: this.props.data
            });
        }
    }


    render() {

        return (
            <div className="trip__carousel">
                {this.state.data && this.state.data.length >= 1 &&
                    <div className="trip__carousel-container">
                        {this.state.data.map((item, i) => (
                            (typeof item.filepath === 'string' && item.filepath.length >= 1 &&
                                <div key={i} className={"trip__carousel__picture"}>
                                    {item.filepath.endsWith(".mp4") ||
                                        item.filepath.endsWith(".mov") ||
                                        item.filepath.endsWith(".avi") ? (
                                        <video
                                            onClick={() => this.setPicture(item.filepath)}
                                            src={item.filepath}
                                            alt={item.label}
                                            className="trip__carousel__picture-inner"
                                            playsInline
                                            controls
                                            muted
                                            loop
                                            preload="auto"
                                        />
                                    ) : (
                                        <img
                                            onClick={() => this.setPicture(item.filepath)}
                                            src={item.filepath}
                                            alt={item.label}
                                            className="trip__carousel__picture-inner"
                                        />
                                    )}
                                </div>
                            )
                        ))}
                    </div>
                }
                {(!this.state.data || this.state.data.length < 1) && (this.props.target[0]) &&
                    <div className="trip__carousel-container">
                        <div className={"trip__carousel__picture"}>
                            {(this.props.target && this.props.target.length >= 1) &&
                                <img
                                    src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/target+groups/" + this.props.target[0].replace(' ', '+') + ".webp"}
                                    alt={"Trip picture"}
                                    className="trip__carousel__picture-inner"
                                />
                            }
                            {!(this.props.target && this.props.target.length >= 1) &&
                                <img
                                    src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/target+groups/Solo.webp"}
                                    alt={"Trip picture"}
                                    className="trip__carousel__picture-inner"
                                />
                            }
                        </div>
                    </div>
                }
                <div className="trip__carousel__indicator-container">
                    <div onClick={() => this.setPopup("pictures")} className="trip__carousel__indicator text-bold">
                        {/* {this.state.picture + "/" + this.state.data.length} */}
                        See all pictures
                    </div>
                </div>
            </div>
        )
    }
}
